import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const subtitleTextStyle3 = css`
  grid-area: subtitle;
  margin: 0;
`;

const subtitleExpandTextStyle4 = css`
  max-width: 700px;
`;

const mainStyles = css`
  display: inline-block;
  width: 100%;
`;

const expandStyles = css`
  color: ${theme.font.colors.primary};
  cursor: pointer;
  margin-left: 3px;
`;

export const SubtitleStyles = {
  subtitleTextStyle3,
  subtitleExpandTextStyle4,
  mainStyles,
  expandStyles,
};
